import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { Typography } from '@components/Typography';
import { STATUS_PALETTE } from '@components/StatusChip';
import { POST_OUTCOME_GROUPS } from '@constants/social-posts';

const ICON_BY_KEY = {
    published: CheckCircleRoundedIcon,
    queued: ScheduleRoundedIcon,
    notPublished: BlockRoundedIcon,
};

const Row = styled('div')({ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 });
const Item = styled('span')({ display: 'inline-flex', alignItems: 'center', gap: 3 });

const PostOutcomeSummary = ({ posts, t }) => {
    if (!posts?.length) return null;

    const buckets = POST_OUTCOME_GROUPS.map(group => ({
        ...group,
        Icon: ICON_BY_KEY[group.key],
        count: posts.filter(post => group.statuses.includes(post.status)).length,
    }));

    return (
        <Row>
            {buckets.map(({ key, Icon, tone, labelKey, count }) => {
                const color = STATUS_PALETTE[tone]?.fg;
                return (
                    <Tooltip key={key} title={`${count} ${t(labelKey)}`} arrow>
                        <Item>
                            <Icon sx={{ fontSize: 16, color }} />
                            <Typography variant="caption" sx={{ color }}>
                                {count}
                            </Typography>
                        </Item>
                    </Tooltip>
                );
            })}
        </Row>
    );
};

export default PostOutcomeSummary;
